import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { UserImportComponent } from '../../components/UserImportComponent';

const AdminImportPage: React.FC = () => {
  return (
    <AdminLayout>
      <div className="p-8">
        <div className="max-w-7xl mx-auto">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-gray-900">Importar Usuarios</h1>
            <p className="text-gray-600 mt-2">
              Importa usuarios masivamente desde un archivo Excel
            </p>
          </div>
          
          <UserImportComponent />
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminImportPage;
